var Reverb = Reverb || {};

Reverb.MobileTooltips = (function () {
  var body = $('body'),
    active_class = 'mobile-tooltips-active',
    trigger_class = 'mobile-tooltip-trigger',
    parent = null,
    tooltips_list = null;

  function init() {
    if (!isMobile()) return false;

    setupElements();
    handleMobileTooltipActive();
    handleMobileTooltipScroll();
  }

  function setupElements() {
    body.addClass('mobile-tooltips');
    if (!$('.mobile-tooltips-list').length) {
      body.prepend('<aside class="mobile-tooltips-list standard-layout hidden-desktop"></aside>');
    }

    parent = $('.mobile-tooltips');
    tooltips_list = $('.mobile-tooltips-list');
  }

  function handleMobileTooltipActive() {
    $('body').on('click', function (el) {
      populateMobileTooltip(el);
      toggleMobileTooltip(el);
    });
  }

  function handleMobileTooltipScroll() {
    $(window).on('scroll', function (el) {
      tooltips_list.css({ top: $(this).scrollTop() });
      toggleMobileTooltip(el);
    });
  }

  function populateMobileTooltip(el) {
    var target = $(el.target),
      template = target.data('mobileTooltip');

    tooltips_list.html(template);
  }

  function toggleMobileTooltip(el) {
    if (parent.hasClass(active_class)) {
      parent.removeClass(active_class);
    }
    else if ($(el.target).hasClass(trigger_class)) {
      $('input, select, textarea').trigger('blur');
      parent.addClass(active_class);
    }
  }

  function isMobile() {
    return ('ontouchstart' in window && screen.width < 721) ? true : false;
  }

  return {
    init: init
  };
})();

$(Reverb.MobileTooltips.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/mobile/tooltips.js